import { Injectable, NgModule } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterModule,
  Routes,
} from "@angular/router";
import { AppService } from "../apps/app.service";
import { LoggedInGuard } from "../auth/auth.guards";
import { SessionService } from "../session.service";
import { take } from "rxjs/operators";
import { StatsComponent } from "./stats.component";

@Injectable({ providedIn: "root" })
export class StartDateResolve implements Resolve<any> {
  constructor() {}

  resolve() {
    const start = new Date();
    start.setMonth(start.getMonth() - 1);
    start.setHours(0, 0, 0, 0);
    return start;
  }
}

@Injectable({ providedIn: "root" })
export class EndDateResolve implements Resolve<any> {
  constructor() {}

  resolve() {
    const end = new Date();
    end.setHours(23, 59, 59);
    return end;
  }
}

@Injectable({ providedIn: "root" })
export class StatsResolve implements Resolve<any> {
  constructor(
    private AppService: AppService,
    private SessionService: SessionService,
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const start = route.parent!.data.start;
    const end = route.parent!.data.end;

    return this.AppService.getStats(
      this.SessionService.currentAccountValue!.accountID,
      this.SessionService.currentAppValue!.id,
      start,
      end,
      'day',
      [this.SessionService.currentAppValue!.id],
      false
    ).pipe(take(1));
  }
}

const routes: Routes = [
  {
    path: "key-metrics",
    canActivate: [LoggedInGuard],
    runGuardsAndResolvers: "always",
    data: { sidebar: "admin" },
    children: [
      {
        path: "",
        resolve: {
          start: StartDateResolve,
          end: EndDateResolve,
        },
        children: [
          {
            path: "",
            data: { title: "Stats" },
            component: StatsComponent,
            resolve: {
              stats: StatsResolve,
            },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StatsRoutingModule {}

const statsModuleLazyLoadRoutes: Routes = [
  {
    path: "stats",
    loadChildren: () =>
      import("./stats.module").then((m) => m.StatsModule),
  },
];

export { statsModuleLazyLoadRoutes as statsModuleLazyLoadRoutes };
